/*
 * Copyright (c) 2019. Willker Gomes
 */

import api, { endpoints } from '~/services/api';

class ProductModuleService {
  static getProductModules = async (filter) => {
    const { data: response } = await api.post(
      endpoints.product['module'].getProductModules,
      filter
    );
    return response.data;
  };
}
export default ProductModuleService;
